<template>
  <div>

      <div>
        <v-progress-linear
          v-model="progress"
          color="light-blue"
          height="25"
          reactive
        >
          <strong>{{ progress }} %</strong>
        </v-progress-linear>
      </div>
    <v-alert
      v-if="validationResult"
      border="left"
      :color="statusColor(validationResult.status)"
      dark
      class="mb-4"
    >
      <div><strong>{{ validationResult.message }}</strong></div>
      <div>
        Status: {{ validationResult.status }} |
        Errors: {{ validationResult.total_errors }} |
        Groups: {{ validationResult.total_groups }}
      </div>
      <div v-if="validationResult.truncated">
        Showing sample rows only (truncated).
      </div>
    </v-alert>

    <v-alert
      v-if="validationJob && (validationJob.status === 'queued' || validationJob.status === 'running')"
      border="left"
      color="indigo"
      dark
      class="mb-4"
    >
      <div><strong>{{ validationJob.message || 'Validation in progress' }}</strong></div>
      <div>
        Job: {{ validationJobId }} |
        Progress: {{ validationJob.progress ? validationJob.progress.completed_sheets : 0 }}/{{ validationJob.progress ? validationJob.progress.total_sheets : 0 }} sheets
        ({{ validationJob.progress_pct || 0 }}%)
      </div>
      <div v-if="validationJob.progress && validationJob.progress.current_sheet">
        Current: {{ validationJob.progress.current_file || '-' }} / {{ validationJob.progress.current_sheet }}
      </div>
      <div>Auto-refresh: every 5 seconds</div>
    </v-alert>

    <v-alert v-if="message" border="left" color="blue-grey" dark>
      <pre>{{ message }}</pre>
    </v-alert>

    <v-card
      v-if="validationResult && validationResult.files && validationResult.files.length"
      class="mb-4"
      outlined
    >
      <v-card-title>Validation Details</v-card-title>
      <v-card-text>
        <div
          v-for="fileResult in validationResult.files"
          :key="fileResult.file_key"
          class="mb-6"
        >
          <div class="font-weight-bold">
            {{ fileResult.file_name || fileResult.file_key }}
          </div>
          <div class="text--secondary mb-2">
            Status: {{ fileResult.status }} |
            Errors: {{ fileResult.total_errors }} |
            Groups: {{ fileResult.total_groups }}
          </div>

          <v-simple-table
            dense
            v-if="fileResult.error_groups && fileResult.error_groups.length"
          >
            <thead>
              <tr>
                <th>Sheet</th>
                <th>Rule</th>
                <th>Column</th>
                <th>Count</th>
                <th>Sample rows</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(group, index) in fileResult.error_groups"
                :key="`${fileResult.file_key}-${group.code}-${group.column}-${index}`"
              >
                <td>{{ group.sheet_name || '-' }}</td>
                <td>{{ group.message }}</td>
                <td>{{ group.column || '-' }}</td>
                <td>{{ group.count }}</td>
                <td>{{ formatExamples(group.examples) }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-card-text>
    </v-card>

    <v-row no-gutters justify="center" align="center">
      <v-col cols="8">
        <v-file-input
          show-size
          label="New Planning File"
          v-model="newPlanningFile"
          @change="selectFile"
        ></v-file-input>
      </v-col>
            <v-col cols="4" class="pl-2">
        <v-btn color="success" dark small @click="upload">
          Upload
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters justify="center" align="center">
         <v-col cols="8">
            <v-file-input
                prepend-icon="mdi-arrange-send-backward"
                :label="'Loans Planning File'"
                v-model="loansPlanningFile"
                show-size
                accept="application/*"
                @change="selectFile">
            </v-file-input>
            </v-col>

      <v-col cols="4" class="pl-2">
        <v-btn color="success" dark small @click="upload">
          Upload
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
     </v-row>
         <v-row no-gutters justify="center" align="center">
         <v-col cols="8">
            <v-file-input
                prepend-icon="mdi-arrange-send-backward"
                :label="'Fixed assets planning rates'"
                v-model="fixedAssetsPlanningRates"
                show-size
                accept="application/*"
                @change="selectFile">
            </v-file-input>
            </v-col>

      <v-col cols="4" class="pl-2">
        <v-btn color="success" dark small @click="upload">
          Upload
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
     </v-row>
         <v-row no-gutters justify="center" align="center">
         <v-col cols="8">
            <v-file-input
                prepend-icon="mdi-arrange-send-backward"
                :label="'Fixed assets'"
                v-model="fixedAssets"
                show-size
                accept="application/*"
                @change="selectFile">
            </v-file-input>
            </v-col>

      <v-col cols="4" class="pl-2">
        <v-btn color="success" dark small @click="upload">
          Upload
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
     </v-row>
         <v-row no-gutters justify="center" align="center">
         <v-col cols="8">
            <v-file-input
                prepend-icon="mdi-arrange-send-backward"
                :label="'Fixed Assets Support'"
                v-model="fixedAssetsSupport"
                show-size
                accept="application/*"
                @change="selectFile">
            </v-file-input>
            </v-col>

      <v-col cols="4" class="pl-2">
        <v-btn color="success" dark small @click="upload">
          Upload
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
     </v-row>
    <v-row no-gutters justify="center" align="center">
         <v-col cols="8">
            <v-file-input
                prepend-icon="mdi-arrange-send-backward"
                :label="'Archive Planning File'"
                v-model="archivePlanningFile"
                show-size
                accept="application/*"
                @change="selectFile">
            </v-file-input>
            </v-col>

      <v-col cols="4" class="pl-2">
        <v-btn color="success" dark small @click="upload">
          Upload
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
     </v-row>
    <v-row no-gutters justify="center" align="center">
         <v-col cols="8">
            <v-file-input
                prepend-icon="mdi-arrange-send-backward"
                :label="'Risk & Funding File'"
                v-model="riskPlanningFile"
                show-size
                accept="application/*"
                @change="selectFile">
            </v-file-input>
            </v-col>

      <v-col cols="4" class="pl-2">
        <v-btn color="success" dark small @click="upload">
          Upload
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
     </v-row>
    <!-- CR-10: internal files for the archive import (mapping coverage, warnings only) -->
    <v-row no-gutters justify="center" align="center">
      <v-col cols="8">
        <v-file-input
          prepend-icon="mdi-arrange-send-backward"
          :label="'FINREP (archive import)'"
          v-model="finrepFile"
          show-size
          accept=".xlsx,.xlsm"
          @change="selectFile">
        </v-file-input>
      </v-col>
      <v-col cols="4" class="pl-2">
        <v-btn color="success" dark small @click="upload">
          Upload
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters justify="center" align="center">
      <v-col cols="8">
        <v-file-input
          prepend-icon="mdi-arrange-send-backward"
          :label="'Business Report (archive import)'"
          v-model="brFile"
          show-size
          accept=".xlsx,.xlsm"
          @change="selectFile">
        </v-file-input>
      </v-col>
      <v-col cols="4" class="pl-2">
        <v-btn color="success" dark small @click="upload">
          Upload
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'upload-files',
  data() {
    return {
      progress: 0,
      message: '',
      validationResult: null,
      validationJobId: null,
      validationJob: null,
      pollingTimer: null,
      fixedAssetsPlanningRates: [],
      fixedAssets: [],
      fixedAssetsSupport: [],
      newPlanningFile: [],
      loansPlanningFile: [],
      archivePlanningFile: [],
      riskPlanningFile: [],
      finrepFile: [],
      brFile: [],
    };
  },

  beforeDestroy() {
    this.clearPolling();
  },

 methods: {
    selectFile(file) {
      this.progress = 0;
      this.clearPolling();
      this.validationResult = null;
      this.validationJobId = null;
      this.validationJob = null;
      this.message = file ? `Selected file: ${file.name}` : '';
    },

    async upload() {
      if (!this.loansPlanningFile
        && !this.fixedAssetsPlanningRates
        && !this.fixedAssets
        && !this.fixedAssetsSupport
        && !this.newPlanningFile
        && !this.archivePlanningFile
        && !this.riskPlanningFile
        && !this.finrepFile
        && !this.brFile) {
        this.message = 'Please select a file!';
        return;
      }
      this.message = '';
      this.clearPolling();
      this.validationResult = null;
      this.validationJobId = null;
      this.validationJob = null;


        const formData = new FormData();
        const baseUrl = localStorage.getItem('api_link');
        const apiToken = process.env.VUE_APP_API_TOKEN;
        /*
        Add the form data we need to submit
        */
        formData.append('fa_rates_file', this.fixedAssetsPlanningRates);
        formData.append('fa_import_file', this.fixedAssets);
        formData.append('fa_support_file', this.fixedAssetsSupport);
        formData.append('fa_new_planning_file', this.newPlanningFile);
        formData.append('loans_planning_file', this.loansPlanningFile);
        formData.append('archive_planning_file', this.archivePlanningFile);
        formData.append('risk_planning_file', this.riskPlanningFile);
        formData.append('finrep_file', this.finrepFile);
        formData.append('br_file', this.brFile);
        /*
        Make the request to the POST /single-file URL
        */
        try {
          const response = await axios.post(`${baseUrl}/validate/jobs`,
            formData,
            {
              headers: {
                'x-api-key': apiToken,
                'content-type': 'multipart/form-data',
              },
              onUploadProgress: (progressEvent) => {
                this.progress = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100), 10);
              },
            });

          this.validationJobId = response.data.job_id;
          this.validationJob = {
            status: 'queued',
            message: response.data.message || 'Validation queued',
            progress_pct: 0,
            progress: {
              total_files: 0,
              total_sheets: 0,
              completed_sheets: 0,
              current_file: null,
              current_sheet: null,
            },
          };
          this.message = `Validation started (job ${this.validationJobId})`;
          await this.pollValidationStatus(baseUrl, apiToken);
          if (this.validationJob
            && (this.validationJob.status === 'queued' || this.validationJob.status === 'running')) {
            this.pollingTimer = setInterval(() => {
              this.pollValidationStatus(baseUrl, apiToken);
            }, 5000);
          }
        } catch (e) {
          try {
            const fallbackResponse = await axios.post(`${baseUrl}/validate/`,
              formData,
              {
                headers: {
                  'x-api-key': apiToken,
                  'content-type': 'multipart/form-data',
                },
              });
            if (fallbackResponse.data && typeof fallbackResponse.data === 'object' && fallbackResponse.data.files) {
              this.validationResult = fallbackResponse.data;
              this.message = '';
            } else {
              this.message = String(fallbackResponse.data);
              this.validationResult = null;
            }
          } catch (fallbackError) {
            this.validationResult = null;
            this.validationJobId = null;
            this.validationJob = null;
            this.message = (fallbackError.response && fallbackError.response.data && fallbackError.response.data.message)
              ? fallbackError.response.data.message
              : 'Validation request failed';
            throw new Error(this.message);
          }
        }
    },
    clearPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    async pollValidationStatus(baseUrl, apiToken) {
      if (!this.validationJobId) return;
      try {
        const response = await axios.get(`${baseUrl}/validate/jobs/${this.validationJobId}`, {
          headers: {
            'x-api-key': apiToken,
          },
        });
        this.validationJob = response.data;
        this.progress = Math.round(response.data.progress_pct || 0);

        if (response.data.status === 'done') {
          this.clearPolling();
          if (response.data.result && response.data.result.files) {
            this.validationResult = response.data.result;
            this.message = '';
          } else {
            this.message = response.data.message || 'Validation completed';
          }
        } else if (response.data.status === 'error') {
          this.clearPolling();
          this.message = response.data.message || 'Validation failed';
        }
      } catch (error) {
        this.clearPolling();
        const apiMessage = error.response && error.response.data && error.response.data.message;
        this.message = apiMessage
          ? `Failed to refresh validation status: ${apiMessage}`
          : 'Failed to refresh validation status';
      }
    },
    statusColor(status) {
      if (status === 'ok') return 'green';
      if (status === 'invalid') return 'orange darken-2';
      return 'red darken-2';
    },
    formatExamples(examples) {
      if (!examples || !examples.length) return '-';
      return examples
        .map(item => item.row)
        .filter(row => row !== null && row !== undefined)
        .join(', ');
    },
},
};
</script>
